import { getItem } from "./localStorageService";

export default function getToken() {
  return getItem("loginToken") || "";
}

export const getAuthToken = () => {
  return getItem("AUTH");
};
